import axios from 'axios';
import useConfig from '@/composables/useConfig';
import { CHATBOT_TYPES } from '@/js/constants';

export default class ChatbotService {
  constructor() {
    const { currentConfig, getCurrentDfLanguage } = useConfig();
    const { chatbotCredentials } = currentConfig.value;
    const customCredentials = chatbotCredentials.find((cbc) => cbc.type === CHATBOT_TYPES.CUSTOM);
    const robotCredentials = chatbotCredentials.find((cbc) => cbc.type === CHATBOT_TYPES.ROBOT);
    const globalCredentials = chatbotCredentials.find((cbc) => cbc.type === CHATBOT_TYPES.GLOBAL);

    this.credentials = customCredentials || robotCredentials || globalCredentials;
    this.currentLanguage = getCurrentDfLanguage();
  }

  async sendRequest(text) {
    const { endpoint, apiKey } = this.credentials;
    try {
      const { data } = await axios.post(endpoint, { message: { text } }, {
        params: {
          accessToken: apiKey,
          lang: this.currentLanguage,
        },
      });

      const { type, message } = data;
      return ['success', 'auth_completed'].includes(type) ? message[0].text : '';
    } catch (e) {
      return '';
    }
  }
}
